import { useEffect, useState } from "react";
import { BadgeCheck, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { gameIdError } from "@/lib/member";

export const useNickCheck = (productId, gameId) => {
  const [res, setRes] = useState({ status: "idle" });
  useEffect(() => {
    if (productId !== "royal_dream" || !gameId || gameIdError(gameId)) {
      setRes({ status: "idle" });
      return undefined;
    }
    let live = true;
    setRes({ status: "checking" });
    const t = setTimeout(() => {
      api.get(`/check-id/${productId}`, { params: { id: gameId } })
        .then((r) => live && setRes(r.data))
        .catch(() => live && setRes({ status: "unavailable" }));
    }, 600);
    return () => {
      live = false;
      clearTimeout(t);
    };
  }, [productId, gameId]);
  return res;
};

export const nickBlockMsg = (n) => (n.status === "invalid" ? "ID tidak ditemukan. Periksa kembali ID Anda." : n.status === "checking" ? "Tunggu sebentar, ID sedang dicek." : "");

export const NickStatus = ({ n, light = false }) => {
  if (n.status === "checking") {
    return <p className={`mt-1 inline-flex items-center gap-1 text-[11px] font-bold ${light ? "text-slate-500" : "text-zinc-400"}`} data-testid="nick-checking"><Loader2 size={12} className="animate-spin" /> Mengecek ID…</p>;
  }
  if (n.status === "valid") {
    return (
      <p className={`mt-1.5 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-extrabold ${light ? "bg-emerald-50 text-emerald-700" : "bg-emerald-500/15 text-emerald-300"}`} data-testid="nick-valid">
        <BadgeCheck size={15} /> <span data-testid="nick-name">{n.nickname}</span>
        <span className={`ml-1 text-[10px] font-bold ${light ? "text-emerald-600" : "text-emerald-400/80"}`}>· ID terverifikasi</span>
      </p>
    );
  }
  if (n.status === "invalid") {
    return <p className="mt-1 inline-flex items-center gap-1 text-[11px] font-bold text-rose-500" data-testid="nick-invalid"><XCircle size={12} /> ID tidak ditemukan</p>;
  }
  return null;
};
